//  /src/components/Footer/index.tsx
import React, { useState, FC } from 'react'
import { useHistory } from 'react-router-dom'
import StyledButton from 'components/Button'
import FormInputField from 'components/FormInputField'
import FooterMap from 'components/FooterMap'
import useWindowSize from 'customHooks/useWindowSize'
import { useAuth } from 'customHooks/useAuth';
import { useSubscribeToMailingList } from 'customHooks/useSubscribeToMailingList';
import { Link } from 'react-router-dom';
import { 
  FooterContainer,
  FooterFormContainer,
  FooterDetailsContainer,
  FooterBottomContainer,
  FooterBox
} from './style'
import { FacebookIcon, TwitterIcon, InstagramIcon, BigLogoNew } from 'assets/icons'



type FooterProps = {
  disableFooter?: boolean;
  disableMap?: boolean;
};

const Footer: FC<FooterProps> = ({ disableFooter, disableMap }) => {


  const [emailError, setEmailError] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState('');
  
  const [emailSuccess, setEmailSuccess] = useState(false);
  const [emailSuccessMessage, setEmailSuccessMessage] = useState('');

  const { validToken } = useAuth();
  const history = useHistory();
  const [email, setEmail] = useState('');
  useWindowSize()

  const { subscribe } = useSubscribeToMailingList();

  const handleSubscribe = async () => {
    setEmailError(false);
    setEmailErrorMessage('');
    setEmailSuccess(false);
    setEmailSuccessMessage('');
  
    if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      setEmailError(true);
      setEmailErrorMessage('Invalid email address');
      return;
    }
  
    const result = await subscribe({ email });
  
    if (result.success) {
      setEmailSuccess(true);
      setEmailSuccessMessage(result.message || 'Thank you for subscribing');
      setEmail('');
    } else {
      setEmailError(true);
      setEmailErrorMessage(result.message || 'Subscribe failed!');
    }
  };

  return (
    <FooterBox>
      {!disableFooter ? (
        <FooterContainer>
          {disableMap? null:<FooterMap />}
          {!validToken?
            <FooterFormContainer centerWidth="40%" centerHeight="40%">
              <div className="footerContentContainer">
                <div className="footerSubscribeContainer">
                  <div className="footerSubscribeTitle">
                    Receive a 5% discount on your next stay at Rook Hotel
                  </div>
                  <div className="footerSubscribeDescription">
                    Sign up to our mailing list for an instant discount code!
                  </div>
                  <div className="footerInputContainer">
                    <FormInputField
                      className="footerInput"
                      placeholder="Your email"
                      marginBottom="0"
                      inputHeight="48px"
                      value={email}
                      error={emailError}
                      errorMessage={emailErrorMessage}
                      success={emailSuccess}
                      successMessage={emailSuccessMessage}
                      onChange={(e) => {
                        setEmail(e.target.value);

                        if (emailError) {
                          setEmailError(false);
                          setEmailErrorMessage('');
                        }

                        if (emailSuccess) {
                          setEmailSuccess(false);
                          setEmailSuccessMessage('');
                        }
                      }}
                    />
                    <StyledButton
                      className="footerSignUpButton"
                      width="98px"
                      height="48px"
                      onClick={handleSubscribe}
                    >
                      Sign Up
                    </StyledButton>
                  </div>
                </div>
              </div>
            </FooterFormContainer>
            : 
            <FooterFormContainer centerWidth="100%" centerHeight="100%">
              <div className="innerContainer">
                <div className="footerContentContainer">
                  <div className="footerHelpContainer">
                    <div className="footerHelpTitle">
                    Get Help During Your Stay
                    </div>
                    <div className="footerHelpDescription">
                    Whether you have a question, need booking assistance, or just want some local tips, our Help Center is here for you. Explore our resources or reach out directly to ensure your stay is nothing short of exceptional!
                    </div>
                    <StyledButton
                      width="162px"
                      height="48px"
                      margin="24px 0 16px 0"
                      onClick={() => {
                        history.push('/help')
                      }}
                    >
                      Need Assistance
                    </StyledButton>
                  </div>
                </div>
              </div>
            </FooterFormContainer>
          }
          <FooterDetailsContainer>
            <div className="innerContainer">
              <div className="footerDetails">
                <div className="footerDetail">
                  <div className="footerDetailsTitle">About Us</div>
                  <div className="footerDetailsContent">
                    <div>
                      <a className="siteLink" href='/' >Home</a>        
                    </div>
                    <div>
                      <a className="siteLink" href='/about-us' >About Rook Hotel</a>        
                    </div>
                    <div>
                      <a className="siteLink" href='/contact-us' >Contact Us</a>        
                    </div>
                    <div>
                      <a className="siteLink" href='/discover' >Discover</a>        
                    </div>
                    <div>
                      <a className="siteLink" href='/cancellation-policy' >Cancellation Policy</a>        
                    </div>
                  </div>
                </div>
                <div className="footerDetail">
                  <div className="footerDetailsTitle">Contact Information</div>
                  <div className="footerDetailsContent">
                    <div><span className='highLight'>Phone: </span><a href='tel:+19059494000'> +1 (905) 949-4000</a></div>
                    <div><span className='highLight'>Email: </span><a href="mailto:info@rookhotel.com"> info@rookhotel.com</a></div>
                  </div>
                </div>
                <div className="footerDetail">
                  <div className="footerDetailsTitle">Address</div>
                  <a
                    href="https://www.google.com/maps?cid=9892775027598466451"
                    className="footerDetailsContent address"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div>3660 Hurontario St.</div>
                    <div>Mississauga, ON</div>
                  </a>
                </div>
                <div className="logoContainer">
                  <div className='bigLogo'>
                  <a href='/' ><BigLogoNew /></a>
                  </div>
                  <StyledButton
                    width="153px"
                    height="48px" 
                    onClick={() => {
                      window.open('https://www.google.com/maps?cid=9892775027598466451', '_blank')
                    }}
                  >
                    View on Map
                  </StyledButton>
                </div>
              </div>

            </div>
          </FooterDetailsContainer>
          <FooterBottomContainer>
          <div className="footerBottomContent">
            <div className="footerBottomIcons">
              <div className='socialMedia'>
                <a href="https://www.facebook.com/rookhotel" target="_blank" rel="noopener noreferrer">
                  <FacebookIcon />
                </a>
                <a href="https://twitter.com/rookhotel" target="_blank" rel="noopener noreferrer">
                  <TwitterIcon />
                </a>
                <a href="https://www.instagram.com/rookhotel" target="_blank" rel="noopener noreferrer">
                  <InstagramIcon />
                </a>
              </div>
            </div>
            
              <div className='policy'>
                <Link to="/terms-and-conditions" className="terms">
                  Terms
                </Link>
                <Link to="/privacy-policy" className="privacy">
                  Privacy
                </Link>
              </div>
              <div className="copy">
                &copy; {new Date().getFullYear()} Rook Hotel. All Rights Reserved.
              </div>
            
            </div>
          </FooterBottomContainer>
        </FooterContainer>
      ) : null}
    </FooterBox>
  )
}

export default Footer;
